import { render } from "./burger_item.vue?vue&type=template&id=fc273556&scoped=true"
import script from "./burger_item.vue?vue&type=script&lang=js"
export * from "./burger_item.vue?vue&type=script&lang=js"

import "./burger_item.vue?vue&type=style&index=0&id=fc273556&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc273556"]])

export default __exports__